import messagesStore from './messages'

export default {
  namespaced: true,
  modules: {
    messages: messagesStore
  }
};
